<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.55"
    height="15.176"
    viewBox="0 0 17.55 15.176"
    aria-hidden="true"
  >
    <g
      id="Group_44004"
      data-name="Group 44004"
      transform="translate(-230.375 -53.997)"
    >
      <g
        id="streamline-icon-ads-window_20x20"
        data-name="streamline-icon-ads-window@20x20"
        transform="translate(230.975 57.2)"
      >
        <path
          id="Path_44570"
          data-name="Path 44570"
          d="M17.645,8.75H16.01a1.636,1.636,0,0,0-1.635,1.635c0,2.452,3.27,2.452,3.27,4.9a1.636,1.636,0,0,1-1.635,1.635H14.375"
          transform="translate(-1.295 -8.75)"
          fill="none"
          stroke="#fab62f"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
        />
        <path
          id="Path_44571"
          data-name="Path 44571"
          d="M4.375,16.925v-6.54a1.635,1.635,0,1,1,3.27,0v6.54"
          transform="translate(-4.375 -8.75)"
          fill="none"
          stroke="#fab62f"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
        />
        <path
          id="Path_44572"
          data-name="Path 44572"
          d="M4.375,12.5h3.27"
          transform="translate(-4.375 -7.595)"
          fill="none"
          stroke="#fab62f"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
        />
        <path
          id="Path_44573"
          data-name="Path 44573"
          d="M9.375,16.925a3.27,3.27,0,0,0,3.27-3.27V12.02a3.27,3.27,0,0,0-3.27-3.27Z"
          transform="translate(-2.835 -8.75)"
          fill="none"
          stroke="#fab62f"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
        />
      </g>
      <g
        id="streamline-icon-plane-trip-take-off-cancel_20x20"
        data-name="streamline-icon-plane-trip-take-off-cancel@20x20"
        transform="translate(231.463 54.845)"
      >
        <path
          id="Path_44577"
          data-name="Path 44577"
          d="M10.834,24.334,24.313,10.855"
          transform="translate(-10.834 -10.855)"
          fill="none"
          stroke="#fab62f"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconSalesNoAds',
};
</script>
<style lang="scss" scoped>
.cls-1 {
  fill: none;
  stroke: #fa0;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
